import { type ButtonHTMLAttributes, type ReactNode } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "ghost" | "danger";
  size?: "sm" | "md" | "lg";
  children: ReactNode;
  fullWidth?: boolean;
}

const variants = {
  primary: "btn-gradient text-white font-semibold shadow-lg shadow-brand-500/20",
  secondary:
    "bg-surface-elevated border border-border-default text-text-primary hover:bg-brand-50 dark:hover:bg-brand-800/20 font-medium",
  ghost:
    "text-text-secondary hover:text-text-primary hover:bg-brand-50 dark:hover:bg-brand-800/20 font-medium",
  danger: "bg-red-500/10 text-red-500 hover:bg-red-500/20 font-medium border border-red-500/20",
};

const sizes = {
  sm: "px-3 py-1.5 text-sm rounded-lg",
  md: "px-5 py-2.5 text-sm rounded-xl",
  lg: "px-8 py-3.5 text-base rounded-xl",
};

export function Button({
  variant = "primary",
  size = "md",
  children,
  fullWidth = false,
  className = "",
  ...props
}: ButtonProps) {
  return (
    <button
      className={`focus-visible:ring-brand-500 focus-visible:ring-offset-surface-primary inline-flex items-center justify-center gap-2 transition-[color,background-color,border-color,box-shadow,opacity] focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 ${variants[variant]} ${sizes[size]} ${fullWidth ? "w-full" : ""} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
